var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ejgS5BP8rQp1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 640,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.192843-5.964214)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8 0 0 1.8-321.846981-271.480813)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 121.144674,
    ry: 121.144674,
    transform: "translate(358.139413 287.59792)",
    fill: "#C63F25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: -188.871224,
    y1: 97.29323,
    x2: 188.871225,
    y2: -97.297297,
    transform: "matrix(.770636 0.067422-.097282 1.111943 357.139649 290.181382)",
    fill: "none",
    stroke: "#C63F25",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-1.725648,-3.83997 34.166959,55.739321 34.166961,55.739318 -37.618256,55.739318 -37.618258,55.739319 -1.725648,-3.83997",
    transform: "matrix(.341418 0.525737-.633445 0.411364 529.182829 184.958924)",
    fill: "#C63F25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-1.725648,-3.83997 34.166959,51.77709 34.166961,51.777088 -37.618256,51.777088 -37.618258,51.777089 -1.725648,-3.83997",
    transform: "matrix(.341418 0.525737 0.706802-.459003 185.77185 397.540674)",
    fill: "#C63F25",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-1.27186 1.209611,-0.393026 0.747581,1.028956 -0.747581,1.028956 -1.209611,-0.393026 0,-1.27186",
    transform: "matrix(-1 0 0-1 482.162162 128.45787)",
    fill: "#C63F25",
    strokeWidth: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.e9650335947d61f59be551d7b6f93217.svg";
export { ForwardRef as ReactComponent };